import React from 'react'
import './App.css'
import { HashRouter as Router } from 'react-router-dom'
import Home from './pages'
import { SpeedInsights } from "@vercel/speed-insights/react"

const App = () => {
  return (
    <Router>
      <Home />
      <SpeedInsights />
    </Router>
  )
}

export default App
